export default __webpack_public_path__ + "static/media/moving.965b755a.jpg";